import { Component, Input, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { RenderFilter } from 'gung-list';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HlDisplayPortalFeaturesService } from '../../services/hl-display-portal-features.service';

const imageDataMappings = {
  default: {
    image: 'DEFAULT_2024',
    imagePharma: 'DEFAULT_PHARMA',
    title: '',
    imagePharmacie: 'filters:etag(0698a816fad1e79905a1ea6a202e71e7)/hldisplay/pharmacie-images/Produits.jpg'
  },
  'Concept Vrac': {
    image: 'CONCEPT_VRAC',
    title: 'Concept Vrac'
  },
  'Facing automatique': {
    image: 'FACING_AUTOMATIQUE',
    title: 'Facing Automatique'
  },
  'Porte-étiquettes': {
    image: 'PORTES_ETIQUETTES',
    title: 'Porte-étiquettes',
    imagePharmacie: 'filters:etag(575005339a38da161ad60514d37ef74d)/hldisplay/pharmacie-images/porte-etiquette.jpg'
  },
  'Présentoirs & Paniers': {
    image: 'FRUIT',
    title: 'Présentoirs & Paniers',
    imagePharmacie: 'filters:etag(f4d49fb95e64ad6c233685b883e06c48)/hldisplay/pharmacie-images/Presentoirs et paniers.jpg'
  },
  'Séparateurs & Accessoires': {
    image: 'SEPARATORS',
    title: 'Séparateurs & Accessoires',
    imagePharmacie: 'filters:etag(b20d6bfd9cdc814e9e815564d9c3dd49)/hldisplay/pharmacie-images/Separateurs.jpg'
  },
  'Protection et sécurité': {
    image: 'PROTECTION',
    title: 'Protection et sécurité'
  },
  GravityScoopBins: {
    image: 'CONCEPT_VRAC',
    title: null // when title is null then the title is obtained from the filter (which contains the i18n value name of the category filter)
  },
  ShelfManagementAutomatic: {
    image: 'FACING_AUTOMATIQUE',
    title: null
  },
  PriceCommunication: {
    image: 'PORTES_ETIQUETTES',
    title: null
  },
  FreshProduceSolutions: {
    image: 'FRUIT',
    title: null
  },
  ShelfManagementManual: {
    image: 'SEPARATORS',
    imagePharma: 'SEPARATORS_PHARMA',
    title: null
  },
  ProtectionSafetyEquipment: {
    image: 'PROTECTION',
    title: null
  },
  LightingPowerInfrastructure: {
    image: 'DIGITAL_MISE_EN_LUMIERE',
    imagePharma: 'DIGITAL_MISE_EN_LUMIERE_PHARMA',
    title: null
  },
  StoreCommunicationBranding: {
    image: 'COMMUNICATION_SIGNALETIQUE',
    title: null
  },
  'LightingPowerInfrastructure;DigitalScreensAccessories': {
    // equals to LightingPowerInfrastructure
    image: 'DIGITAL_MISE_EN_LUMIERE',
    title: null
  },
  'DigitalScreensAccessories;LightingPowerInfrastructure': {
    // equals to LightingPowerInfrastructure
    image: 'DIGITAL_MISE_EN_LUMIERE',
    title: null
  },
  'FreshProduceSolutions;DisplayAccessories': {
    // equals to FreshProduceSolutions
    image: 'FRUIT',
    title: null
  },
  'DisplayAccessories;FreshProduceSolutions': {
    // equals to FreshProduceSolutions
    image: 'FRUIT',
    title: null
  },
  ShelfManagementManual_NL: {
    image: 'Header_1_(small_long)',
    title: null
  },
  ShopFittingEquipment_NL: {
    image: 'Header_7_(Small_long).png',
    title: null
  },
  PriceCommunication_NL: {
    image: 'Header_3_(small_long).png',
    title: null
  },
  FreshProduceSolutions_NL: {
    image: 'Header_4_(small_long).png',
    title: null
  },
  'Portes Etiquettes': {
    image: 'PORTES_ETIQUETTES',
    title: 'Porte-étiquettes',
    imagePharmacie: 'filters:etag(575005339a38da161ad60514d37ef74d)/hldisplay/pharmacie-images/porte-etiquette.jpg'
  },
  'Mise en lumière': {
    image: 'DEFAULT_2024',
    title: 'Mise en lumière',
    imagePharmacie: 'filters:etag(d7f18ed5bbb2f22224edc84bae67877d)/hldisplay/pharmacie-images/Adlite.jpg'
  },
  'Impulsion & promotion': {
    image: 'DEFAULT_2024',
    title: 'Impulsion & promotion',
    imagePharmacie: 'filters:etag(9a1c09497809360e03b2a8edb1a9a4c9)/hldisplay/pharmacie-images/Impulsion.jpg'
  },
  'CosmeLine™': {
    image: 'DEFAULT_2024',
    title: 'Cosmeline',
    imagePharmacie: 'filters:etag(8a9297fb2a9b2ebb02c31aa6f7e1585e)/hldisplay/pharmacie-images/Cosmeline.jpg'
  },
  'Communication & signalétique': {
    image: 'DEFAULT_2024',
    title: 'Communication & signalétique',
    imagePharmacie: 'filters:etag(fe672c5c76db2e7945943c3c0257d003)/hldisplay/pharmacie-images/Communication.jpg'
  },
};

const getMappingFromRenderFilters = (filters: RenderFilter[]): { image: string; title: string } | undefined => {
  const selectedCategory = filters
    .filter(filter => filter.name === 'CATEGORY')
    .map(filter => filter.valueList)
    .reduce((acc, curr) => [...curr, ...acc], [])
    .filter(value => value.selected)[0];

  // reset title of default to empty
  imageDataMappings.default.title = '';

  if (!selectedCategory) {
    return imageDataMappings.default;
  }

  let imageDataMapping = imageDataMappings[selectedCategory.valueId] || imageDataMappings.default;

  // in case title is not set then get its value from the filter
  if (!imageDataMapping.title) {
    imageDataMapping.title = selectedCategory.valueName || '';
  }
  return imageDataMapping;
};

@Component({
    selector: 'app-hl-product-list-header',
    templateUrl: './hl-product-list-header.component.html',
    styleUrls: ['./hl-product-list-header.component.scss'],
    standalone: false
})
export class HlProductListHeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  renderFilters: RenderFilter[];

  private unsubscribe: Subject<boolean> = new Subject<boolean>();

  showImage = true;
  imageData: { image: string; title: string } | undefined;

  constructor(
    public translateService: TranslateService,
    protected hlDisplayPortalFeaturesService: HlDisplayPortalFeaturesService
  ) {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.getImageData(this.hlDisplayPortalFeaturesService.getPortalName());
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  getImageData(portalName?: string): void {
    const mapping = getMappingFromRenderFilters(this.renderFilters);
    if (!!mapping) {
      const title = mapping.title;
      let image = mapping.image;

      const imagePharmacie = mapping['imagePharmacie'];
      if (portalName === 'pharmacie' && !!imagePharmacie) {
        this.imageData = { title, image: `https://cdn3.gung.io/fit-in/0x0/${imagePharmacie}` };
      } else {
        if (image.includes('.')) {
          this.imageData = { title, image: `assets/product-list-headers/${image}` };
        } else {
          this.imageData = { title, image: `assets/product-list-headers/${image}.jpg` };
        }
      }
    } else {
      this.imageData = undefined;
    }
  }
}
